<template>
  <div class="dashboard-ai-guides">
    <div class="dashboard-ai-guides-header">
      <div class="layer-title">
        <p>{{ $t('dashboard.ai.guide.title') }}</p>
      </div>
    </div>
    <div class="dashboard-ai-guides-body">
      <div class="tag-select-list">
        <div class="tag-item" v-for="category in categoryList" :key="category">
          <button :class="['tag', category, { selected: category === selectedTag }]" @click="selectTag(category)">{{ $t(`dashboard.ai.guide.category.${category}`) }}</button>
        </div>
      </div>
      <div class="guide-list">
        <div class="guide-item" v-for="guide in filteredQuestionGuides" :key="guide.query">
          <div class="guide-item-top">
            <div class="tag-list">
              <p :class="['tag', guide.category]">{{ $t(`dashboard.ai.guide.category.${guide.category}`) }}</p>
              <p class="tag">{{ guide.tag }}</p>
            </div>
            <p class="guide-question">{{ guide.query }}</p>
          </div>
          <div class="guide-item-bottom">
            <div class="guide-image">
              <div v-html="guide.svg"></div>
            </div>
            <div class="copy-button" @click="copyQuestion(guide.query, $event)">
              <span>{{ $t('dashboard.ai.guide.send') }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button class="close-button" @click="$emit('close')">
      <i class="icon icon--close-size32"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'DashboardAiGuides',
  data () {
    return {
      selectedTag: 'all',
      categoryList: ['all', 'cLevel', 'marketer', 'pm', 'designer', 'data']
    }
  },
  computed: {
    questionGuides () {
      return Object.values(this.$t('dashboard.ai.guide.items'))
    },
    filteredQuestionGuides () {
      if (this.selectedTag === 'all') {
        return this.questionGuides
      } else {
        return this.questionGuides.filter(guide => guide.category === this.selectedTag)
      }
    }
  },
  mounted () {
    document.body.classList.add('dimmed-open')
  },
  created () {},
  beforeDestroy () {
    document.body.classList.remove('dimmed-open')
  },
  methods: {
    copyQuestion (question) {
      this.$emit('updatePrompt', question)
      this.$emit('close')
    },
    selectTag (category) {
      this.selectedTag = category
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard-ai-guides {
  @include positionXYcenter;
  position: relative;
  display: flex;
  flex-direction: column;
  width: 1170px;
  padding-top: 28px;
  border-radius: 14px;
  background-color: #F5F7F9;
  font-weight: 400;
  color: #2f2f2f;
  box-sizing: border-box;
  overflow: hidden;

  .close-button {
    position: absolute;
    top: 15px;
    right: 15px;
    i {
      background-color: transparent;
    }
  }
  &-header {
    position: relative;
    @include flexYcenter;
    gap: 26px;
    padding: 0 24px;
    margin-bottom: 25px;
    .layer-title {
      @include flexYcenter;
      gap: 8px;
      color: #2f2f2f;
      font-size: 15px;
      font-weight: 600;
    }
  }
  &-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 15px;
    border-radius: 14px;

    .tag-select-list {
      @include flexYcenter;
      gap: 6px;
      padding: 0 24px;
      .tag-item {
        .tag {
          cursor: pointer;
          padding: 10px 20px;
          border-radius: 100px;
          background-color: #fff;
          border: 1px solid #E2E8F0;
          color: #444;
          font-size: 14px;
          font-weight: 600;
          &.selected {
            background-color: #EC0047;
            color: #fff;
            border-color: #EC0047;
          }
        }
      }
    }
    .guide-list {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      grid-auto-rows: auto;
      gap: 8px;
      height: 600px;
      overflow-y: auto;
      padding: 8px 24px 24px;
      align-content: start;
      .guide-item {
        display: flex;
        flex-direction: column;
        gap: 20px;
        justify-content: space-between;
        box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.1) 0px 4px 6px -4px;
        border-radius: 8px;
        background-color: #fff;
        padding: 16px;
        box-sizing: border-box;
        &-top {
          display: flex;
          flex-direction: column;
          gap: 16px;
          .tag-list {
            @include flexYcenter;
            gap: 8px;
            .tag {
              padding: 4px 12px;
              border-radius: 100px;
              background-color: #f3f4f6;
              font-size: 12px;
              font-weight: 600;
              color: #444;
              &.cLevel {
                background-color: #dbeafe;
                color: #0a2c4d;
              }
              &.pm {
                background-color: #fef9db;
                color: #4d250a;
              }
              &.data {
                background-color: #dbdefe;
                color: #210a4d;
              }
              &.designer {
                background-color: #f3e9f5;
                color: #4d0a39;
              }
              &.marketer {
                background-color: #fde9e9;
                color: #4d0a0a;
              }
            }
          }
          .guide-question {
            font-size: 18px;
            line-height: 1.25;
            font-weight: 500;
            color: #2f2f2f;
          }
        }
        &-bottom {
          display: flex;
          flex-direction: column;
          gap: 12px;
          .guide-image > div {
            @include flexXYcenter;
            gap: 8px;
            flex-direction: column;
            background-color: #F8FAFC;
            padding: 20px 0;
            margin: 0 -16px;
            span {
              font-size: 14px;
              color: #444;
            }
          }
          .copy-button {
            @include flexXYcenter;
            gap: 4px;
            padding: 12px 12px;
            border-radius: 4px;
            border: 1px solid #EC0047;
            color: #444;
            font-size: 14px;
            font-weight: 500;
            color: #EC0047;
            cursor: pointer;
            &:hover {
              background-color: #fbf8f9;
            }
          }
        }
      }
    }
  }
}
</style>
